import { PUBLIC_NO_TRAILING_SLASH_URLS_REGEX } from '$env/static/public';
import { MARKETS } from '$lib/services/register/constants';
import { HOSTS_PER_MARKET } from './constants';

export const removeMarketFromUrl = (url: string) => {
    const marketsRegexp = Object.values(MARKETS).join('|');

    return url.replace(new RegExp(`^/(${marketsRegexp})/`, 'u'), '/');
};

export const ensureNoTrailingSlash = (url: string) => (!url ? url : url.replace(/\/+$/gu, ''));
export const ensureTrailingSlash = (url: string) => (!url || url.endsWith('/') ? url : `${url}/`);

export const ensureUrlTrailingSlash = (url: string, exceptions: string[] = []) => {
    if (!url) {
        return url;
    }
    const [path, ...search] = url.split('?');
    const pathWithoutTrailingSlash = ensureNoTrailingSlash(path);
    const fullRegexpString = exceptions.map((regexp) => `(${regexp})`).join('|');

    if (
        fullRegexpString.length > 0 &&
        new RegExp(fullRegexpString, 'gu').test(removeMarketFromUrl(pathWithoutTrailingSlash))
    ) {
        return `${pathWithoutTrailingSlash}${search?.length ? `?${search.join('?')}` : ''}`;
    }

    if (!path.endsWith('/')) {
        return `${ensureTrailingSlash(path)}${search?.length ? `?${search.join('?')}` : ''}`;
    }
    return url;
};
// @ts-expect-error Legacy code witought types
const getUrlWildcard = ({ marketsCopy, pathname, lang }) => {
    // @ts-expect-error Legacy code witought types
    const currentHrefUrl = marketsCopy.find((entry) => entry.market === lang)?.url;
    if (currentHrefUrl && currentHrefUrl.includes('*')) {
        const pathNameWithoutMarket = removeMarketFromUrl(pathname);

        const matched = pathNameWithoutMarket.match(
            new RegExp(currentHrefUrl.replace('*', '(.*)'))
        );
        return matched && matched[1];
    }
    return '';
};

export const HIDDEN_MARKETS = [MARKETS.ROG, MARKETS.ON];

export const removeExcludedMarkets = (markets = []) => {
    // @ts-expect-error Legacy code witought types
    return markets.filter((market) => !HIDDEN_MARKETS.includes(market.market));
};
export const buildHrefLangMetaNew = ({
    lang = '',
    markets = [],
    xDefault = false,
    pathname = ''
} = {}) => {
    const hostPerMarket = HOSTS_PER_MARKET;
    const hostPerMarketObject = hostPerMarket.reduce(
        (acc, entry) => ({ ...acc, [entry.market]: entry }),
        {}
    );

    const marketsCopy = removeExcludedMarkets(markets);
    const wildcard = getUrlWildcard({ marketsCopy, pathname, lang });

    const alternateHrefs = marketsCopy.map((entry) => {
        // @ts-expect-error Legacy code witought types
        const isEn = entry.hreflang === 'en' && entry.locale === 'en' && entry.market === 'en';

        // @ts-expect-error Legacy code witought types
        const configPerMarket = hostPerMarketObject[entry.market] || hostPerMarketObject.default;
        const marketHost = configPerMarket.host;
        const entryUrlWithFixedTrailingSlash = ensureUrlTrailingSlash(
            // @ts-expect-error Legacy code witought types
            entry.url.replace('*', wildcard),
            [PUBLIC_NO_TRAILING_SLASH_URLS_REGEX]
        );
        const finalPath = configPerMarket.stripLang
            ? `${marketHost}${entryUrlWithFixedTrailingSlash}`
            : // @ts-expect-error Legacy code witought types
              `${marketHost}/${isEn ? MARKETS.ROW : entry.market}${entryUrlWithFixedTrailingSlash}`;

        return {
            href: finalPath,
            // @ts-expect-error Legacy code witought types
            market: entry.hreflang
        };
    });

    // @ts-expect-error Legacy code witought types
    const enMarket = marketsCopy.find((m) => m.market === MARKETS.EN);
    const defaultHref =
        xDefault && enMarket
            ? // @ts-expect-error Legacy code witought types
              `${hostPerMarketObject.default.host}${ensureUrlTrailingSlash(enMarket.url, [
                  PUBLIC_NO_TRAILING_SLASH_URLS_REGEX
              ])}`
            : null;

    return {
        alternateHrefs,
        defaultHref
    };
};
